import { Area } from './models/Area'
import { Extension } from './models/Extensions'
import { IQuestion } from './models/IQuestion'

export const questions: IQuestion[] = [
  {
    area: Area.sso,
    extension: Extension.wpo365Login,
    gotoAfter: 'requiresCustomersMaybe',
    innerHtml: 'Do you plan to enable (some) users to sign in with their Microsoft account (SSO, Single Sign-on)?',
    key: 'requiresSso',
    skipTo: 'requiresGraphMailer',
    title: 'Single Sign-on (SSO)',
    skipIf: [],
  },
  {
    area: Area.customers,
    extension: null,
    gotoAfter: 'requiresCustomers',
    innerHtml: `Are you looking to integrate <strong>Azure AD B2C / Entra External ID</strong> for customer identities (instead of connecting WordPress with a regular "workforce" type of tenant)?`,
    key: 'requiresCustomersMaybe',
    title: 'Customer Identity and Access Management',
    skipTo: 'requiresProfilePlus',
    skipIf: [],
  },
  {
    area: Area.customers,
    extension: Extension.wpo365Customers,
    dependsOn: 'requiresCustomersMaybe',
    gotoAfter: 'requiresProfilePlus',
    innerHtml: `Should WPO365 update users in <strong>Azure AD B2C / Entra External ID</strong> from WordPress?`,
    key: 'requiresCustomers',
    title: 'Update Users in the Cloud',
    skipTo: 'requiresProfilePlus',
    skipIf: [],
  },
  {
    area: Area.sso,
    extension: Extension.wpo365LoginPlus,
    gotoAfter: 'requiresEssentials',
    innerHtml: `Should WPO365 automatically update a user's first name, last name, display name, and email address upon signing in with Microsoft?`,
    key: 'requiresProfilePlus',
    title: 'Basic WP User Profile',
    skipTo: 'requiresEssentials',
    skipIf: [],
  },
  {
    area: Area.sso,
    extension: Extension.wpo365Essentials,
    gotoAfter: 'requiresGraphMailer',
    innerHtml: `Do you plan to implement any of the following features?`,
    badges: [
      'Force SSO for the Login Page',
      'Support for Entra Multi-Tenancy',
      'Configure Multiple IdPs',
      'Intercept Manual Login',
      'Custom Login URL',
      'Custom New User Email',
      'Prevent Email / Pwd Change',
      'Single Sign-out / Sign out of M365',
      'B2C Custom Domain',
      'B2C Embedded Login',],
    key: 'requiresEssentials',
    skipTo: 'requiresGraphMailer',
    title: 'Advanced Login / Logout Features',
    skipIf: [],
  },
  {
    area: Area.email,
    extension: Extension.wpo365MsGraphMailer,
    gotoAfter: 'requiresMail',
    innerHtml: `Do you plan to send WordPress emails using Microsoft Graph from one of your M365 Mailboxes?`,
    key: 'requiresGraphMailer',
    title: 'Send WP Emails from any M365 Mailbox',
    skipTo: 'requiresCuf',
    skipIf: [],
  },
  {
    area: Area.email,
    extension: Extension.wpo365Mail,
    dependsOn: 'requiresGraphMailer',
    gotoAfter: 'requiresCuf',
    innerHtml: `Do you plan to implement any of the following features?`,
    badges: [
      'Send attachments > 3 MB',
      'Send emails from a Shared Mailbox',
      'Mail audit log',
      'Auto-retry failed emails',
      'Staging mode'
    ],
    key: 'requiresMail',
    title: 'Advanced Email Features',
    skipTo: 'requiresCuf',
    skipIf: [],
  },
  {
    area: Area.sync,
    extension: Extension.wpo365Pro,
    gotoAfter: 'requiresAvatar',
    innerHtml: `Should WPO365 automatically update a user's profile with attributes from Entra e.g. job title, mobile phone, location, employee ID?`,
    key: 'requiresCuf',
    title: 'Profile Attributes from Entra',
    skipTo: 'requiresAvatar',
    skipIf: [],
  },
  {
    area: Area.sync,
    extension: Extension.wpo365Pro,
    gotoAfter: 'requiresUserSync',
    innerHtml: `Should WPO365 automatically synchronize a user's WordPress avatar with their profile picture from Entra?`,
    key: 'requiresAvatar',
    title: 'WP Avatar from Entra',
    skipTo: 'requiresUserSync',
    skipIf: [],
  },
  {
    area: Area.sync,
    extension: Extension.wpo365Integrate,
    gotoAfter: 'requiresScim',
    innerHtml: `Should WPO365 periodically perform a full synchronization of users from Entra to WordPress?`,
    key: 'requiresUserSync',
    title: 'Full Synchronization of Users (Entra > WordPress)',
    skipTo: 'requiresScim',
    skipIf: [],
  },
  {
    area: Area.sync,
    extension: Extension.wpo365Scim,
    gotoAfter: 'requiresWpRoleAssignment',
    innerHtml: `Do you plan to connect your WordPress website with Entra's Provisioning Service and receive almost real-time incremental updates regarding users and their attributes?`,
    key: 'requiresScim',
    title: 'Entra (User) Provisioning Service',
    skipTo: 'requiresWpRoleAssignment',
    skipIf: ['requiresCustomers'],
  },
  {
    area: Area.rbac,
    extension: Extension.wpo365RolesAccess,
    gotoAfter: 'requiresAccessControl',
    innerHtml: `Should WPO365 automatically assign WP roles to users based based on their Entra Groups or properties?`,
    key: 'requiresWpRoleAssignment',
    title: 'Automatically Assign WordPress Roles',
    skipTo: 'requiresAccessControl',
    skipIf: [],
  },
  {
    area: Area.rbac,
    extension: Extension.wpo365RolesAccess,
    gotoAfter: 'requiresRedirects',
    innerHtml: `Should WPO365 restrict content access for users who are not logged in or based on their Entra groups?`,
    key: 'requiresAccessControl',
    title: 'Role Based Access Control',
    skipTo: 'requiresRedirects',
    skipIf: [],
  },
  {
    area: Area.rbac,
    extension: Extension.wpo365RolesAccess,
    gotoAfter: 'requiresLd',
    innerHtml: `Should WPO365 redirect a user to a specific page after they signed in with Microsoft?`,
    key: 'requiresRedirects',
    title: 'Login Redirect',
    skipTo: 'requiresLd',
    skipIf: [],
  },
  {
    area: Area.rbac,
    extension: Extension.wpo365RolesAccess,
    gotoAfter: 'requiresAppsMaybe',
    innerHtml: `Do you plan to automatically enroll WP users onto LearnDash courses (or groups)?`,
    key: 'requiresLd',
    title: 'LearnDash Integration',
    skipTo: 'requiresAppsMaybe',
    skipIf: [],
  },
  {
    area: Area.apps,
    extension: null,
    gotoAfter: 'requiresApps',
    innerHtml: `Do you plan to embed content from any of the following Microsoft 365 Apps / Services?`,
    badges: [
      'Power BI Reports and Dashboards',
      'SharePoint / OneDrive Lists and Libraries',
      'Entra based searchable Employee Directory',
      'Exchange / Outlook Calendar',
    ],
    key: 'requiresAppsMaybe',
    title: 'Embed Content from M365 Apps',
    skipTo: 'summary',
    skipIf: ['requiresCustomers'],
  },
  {
    area: Area.apps,
    dependsOn: 'requiresAppsMaybe',
    extension: Extension.wpo365Apps,
    gotoAfter: 'summary',
    innerHtml: `Do you require any of the following Microsoft 365 App features?`,
    badges: [
      'Power BI "App Owns Data" Scenario',
      'Navigate into SharePoint Library Folders',
      'Enable Anonymous Users to View Files',
      'Customize Handlebarjs Templates',
      'Embed a Viva Engage (Yammer) Feed',
      'Combine SharePoint Search and the Employee Directory',
    ],
    key: 'requiresApps',
    title: 'Advanced M365 App Features',
    skipTo: 'summary',
    skipIf: ['requiresCustomers'],
  },
  {
    area: Area.summary,
    extension: null,
    gotoAfter: '#',
    innerHtml: '',
    key: 'summary',
    title: 'Your Personal Recommendation',
    skipTo: 'summary',
    skipIf: [],
  },
]